// extracted by mini-css-extract-plugin
export default {"gutterBottom":"SectionHeader_gutterBottom__FZaBq","subTitle":"SectionHeader_subTitle__E6Okv","helperTextalignment":"SectionHeader_helperTextalignment__RF4Cs"};